import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import TableContainer from './components/TableContainer';
import PaginationBar from './components/PaginationBar';
import usePagination10 from './components/hooks/usePagination10';
import DataTable from './components/DataTable';

function SessionsAtivas() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { setPagination } = usePagination10(sessions.length);

  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem('token');
    axios.post(
      `${API_BASE_URL.LOGIN}/sessions/active`,
      null,
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then(res => {
        const parseLoginTime = (s) => {
          const t = s?.loginTime ?? s?.LOGIN_TIME ?? s?.login_time;
          if (Array.isArray(t) && t.length >= 6) {
            const [year, month, day, hour, minute, second] = t.map(v => Number(v));
            return new Date(year, (month || 1) - 1, day || 1, hour || 0, minute || 0, second || 0).getTime();
          }
          if (typeof t === 'string') { const p = Date.parse(t); return isNaN(p) ? 0 : p; }
          return 0;
        };
        const sorted = Array.isArray(res.data)
          ? res.data.slice().sort((a, b) => parseLoginTime(b) - parseLoginTime(a))
          : res.data;
        setSessions(sorted);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const formatTime = (t) => {
    if (Array.isArray(t) && t.length >= 6) {
      return `${String(t[2]).padStart(2,'0')}/${String(t[1]).padStart(2,'0')}/${t[0]} ${String(t[3]).padStart(2,'0')}:${String(t[4]).padStart(2,'0')}:${String(t[5]).padStart(2,'0')}`;
    }
    return t ?? '-';
  };

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="SESSÕES ATIVAS" icon="bi-list-task" closeRoute="/home" backButton={false} />
        <PageContent>
          {loading ? (
            <div>Carregando...</div>
          ) : sessions.length === 0 ? (
            <div className="alert alert-info">Nenhuma sessão ativa encontrada.</div>
          ) : (
            <>
              <TableContainer>
                <DataTable style={{ fontSize: '0.8rem' }} head={
                  <tr>
                    <th>Nº</th>
                    <th>Login</th>
                    <th>Token</th>
                    <th>Localização</th>
                    <th>Horário de Login</th>
                  </tr>}>
                <tbody>
                  {sessions.slice(setPagination.startIndex, setPagination.startIndex + setPagination.rowsPerPage).map((sess, idx) => (
                    <tr key={sess.id || idx}>
                      <td>{setPagination.startIndex + idx + 1}</td>
                      <td>{sess.login ?? sess.cpf ?? '-'}</td>
                      <td style={{maxWidth:'150px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{sess.token ?? '-'}</td>
                      <td>{sess.location && sess.location !== 'null, null, null' ? sess.location : '-'}</td>
                      <td>{formatTime(sess.loginTime)}</td>
                    </tr>
                  ))}
                </tbody>
                </DataTable>
              </TableContainer>
              
            </>
          )}
        </PageContent>
        <PaginationBar setPagination={setPagination} />
      </ResponsiveShadow>
    </Layout>
  );
}

export default SessionsAtivas;
